import { useEffect, useState } from "react";
import CustomTable from "../../core/custom-table";
import { participantsCardLabelMapper, trainingRequestedList } from "./helper";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { ArrowBack } from "@mui/icons-material";
import TrainingRequestedCandidateList from "./training-request-candidate-list";
import SiTextField from "../../core/si-textfield";

const TrainingRequestedList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { startDate, endDate, candidatesDetails } = location.state || {};
  const [requestedCandidatesList, setRequestedCandidatesList] = useState([]);
  const [trainingID, setTrainingID] = useState("");
  const [participantsList, setParticipantsList] = useState([]);
  const [showBtnGrp, setShowBtnGroup] = useState(false);
  const [open, setOpen] = useState(false);
  const [rejectionComment, setRejectionComment] = useState("");
  const [isCompleted, setIsCompleted] = useState(false);
  const [isOEMRequested, setIsOEMRequested] = useState(false);

  useEffect(() => {
    if (candidatesDetails && candidatesDetails.length) {
      renderCandidateDetails(candidatesDetails);
    } else {
      getRequestedCandidateList();
    }
  }, [candidatesDetails, startDate, endDate]);

  const renderCandidateDetails = (candidatesDetails) => {
    candidatesDetails[0]?.approvalStatus === "ACCEPTED"
      ? setShowBtnGroup(false)
      : setShowBtnGroup(true);
    setTrainingID(candidatesDetails[0]?.id);
    setIsCompleted(candidatesDetails[0]?.status === "COMPLETED");
    setIsOEMRequested(candidatesDetails[0]?.requestedBy || false);
    setParticipantsList(
      candidatesDetails[0]?.participants?.map((data, index) => ({
        serialNumber: index + 1,
        ...data,
      }))
    );
    const transformedData = candidatesDetails?.map((listItem, index) => ({
      serialNumber: index + 1,
      oem: listItem?.oem?.name || listItem?.namex || "",
      numberOfParticipants: listItem?.numberOfParticipants,
      course: listItem?.course?.model || listItem?.model || "",
      courseStartDate:
        listItem?.course?.courseDuration.startDate.split("T")[0] ||
        listItem.courseStartDate,
      courseEndDate:
        listItem?.course?.courseDuration.endDate.split("T")[0] ||
        listItem.courseEndDate,
      daysCount: 1,
      venue: listItem?.venue,
      dealerName: listItem?.dealerName,
      state: listItem?.address?.state || "N/A",
      address: listItem?.address?.line1 || "N/A",
      city: listItem?.address?.city || "N/A",
      remarks: listItem?.remarks,
      courseName: listItem?.courseName,
      trainingMode: listItem?.trainingMode,
      approvalStatus: listItem?.approvalStatus || "",
      requestedBy: listItem?.requestedBy || "",
      rejectionComment: listItem?.rejectionComment || "",
    }));
    setRequestedCandidatesList([...transformedData]);
  };

  const getRequestedCandidateList = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.GET_DAY_TRAINING_LIST}?date=${startDate}`,
      null
    ).then((response) => {
      if (response) {
        setTrainingID(response[0]?.id);
        setIsCompleted(response[0]?.status === "COMPLETED");
        setIsOEMRequested(response[0]?.requestedBy || false);
        setParticipantsList(
          response[0]?.participants?.map((data, index) => ({
            serialNumber: index + 1,
            ...data,
          }))
        );
        response[0]?.approvalStatus === "ACCEPTED"
          ? setShowBtnGroup(false)
          : setShowBtnGroup(true);
        const candidateListTableData = response.length
          ? response.map((listItem, index) => {
              return {
                serialNumber: index + 1,
                oem: listItem?.oem.name,
                numberOfParticipants: listItem?.numberOfParticipants,
                course: listItem?.course.model,
                courseStartDate: startDate,
                courseEndDate: endDate,
                daysCount: 1,
                venue: listItem?.venue,
                dealerName: listItem?.dealerName,
                state: listItem?.address?.state || "N/A",
                address: listItem?.address?.line1 || "N/A",
                city: listItem?.address?.city || "N/A",
                remarks: listItem?.remarks,
                courseName: listItem?.courseName,
                trainingMode: listItem?.trainingMode,
                approvalStatus: listItem?.approvalStatus || "",
                rejectionComment: listItem?.rejectionComment || "",
              };
            })
          : [];
        setRequestedCandidatesList([...candidateListTableData]);
      }
    });
  };

  const handleReject = () => {
    setOpen(true);
  };

  const handleAccept = () => {
    let endPoint = requestedCandidatesList[0].requestedBy
      ? `${HOSTNAME}${REST_URLS.ACCEPT_REQUESTED_COURSE}/${trainingID}?status=ACCEPTED`
      : `${HOSTNAME}${REST_URLS.APPROVE_TRAINING_LIST}/${trainingID}?approve=ACCEPTED`;
    invokeApi(HTTP_METHODS.PUT, endPoint)
      .then((response) => {
        if (response.code) {
          toast.error(response.message);
        } else {
          toast.success("Training Scheduled Successfully");
          navigate("/admin/training/training-approval");
        }
      })
      .catch((e) => {
        toast.error("Training Scheduled Failed");
        navigate("/admin/training/training-approval");
      });
  };

  const handleBackNavigation = () => {
    navigate("/admin/training/training-year-view");
  };

  const handleCloseComment = () => {
    setOpen(false);
  };

  const handleSaveComment = () => {
    setOpen(false);
    let endPoint = requestedCandidatesList[0].requestedBy
      ? `${HOSTNAME}${REST_URLS.ACCEPT_REQUESTED_COURSE}/${trainingID}?status=REJECTED&rejectionComment=${rejectionComment}`
      : `${HOSTNAME}${REST_URLS.APPROVE_TRAINING_LIST}/${trainingID}?approve=REJECTED&rejectionComment=${rejectionComment}`;
    invokeApi(HTTP_METHODS.PUT, endPoint).then(
      (response) => {
        if (response.code) {
          toast.error(response.message);
        } else {
          toast.success("Training Scheduled Rejected");
          navigate("/admin/training/training-approval");
        }
      },
      (err) => {
        toast.error("Training Request Reject Failed");
      }
    );
  };

  const addParticipant = (data) => {
    setParticipantsList([...data]);
    updateParticipantList(data);
  };

  const removeParticipant = (data) => {
    setParticipantsList([...data]);
    updateParticipantList(data);
  };

  const updateParticipantList = (data) => {
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.UPDATE_PARTICIPANT_LIST}/${trainingID}`,
      { numberOfParticipants: data.length, participants: data }
    )
      .then((response) => {
        if (response.code) {
          toast.error(response.message);
        } else {
          toast.success("Participants Updated Successfully");
        }
      })
      .catch((e) => {
        toast.error("Participants Update Failed");
      });
  };

  return (
    <>
      <div className="training-request-list-container">
        {requestedCandidatesList.length && showBtnGrp ? (
          <div className="button-container">
            <Button
              variant="contained"
              sx={{
                borderRadius: "5",
                color: "#ffffff",
                backgroundColor: "red",
                "&:hover": { backgroundColor: "red" },
              }}
              onClick={() => handleReject()}
            >
              Reject
            </Button>
            <Button
              variant="contained"
              sx={{
                borderRadius: "5",
                color: "#ffffff",
                backgroundColor: "#74d971",
                "&:hover": { backgroundColor: "#74d971" },
              }}
              onClick={() => handleAccept()}
            >
              Accept
            </Button>
          </div>
        ) : (
          <></>
        )}
        {requestedCandidatesList.length ? (
          <>
            <div className="training-request-heaeder">
              <ArrowBack
                fontSize="small"
                onClick={() => handleBackNavigation()}
              />
              <div className="title-container">
                <span className="training-title">Training</span>
                <div className="list-title">Training Request Received</div>
              </div>
            </div>
            <div className="request-details-card-container">
              <div className="card-content">
                {requestedCandidatesList.length &&
                  participantsCardLabelMapper.map(({ label, value }) => (
                    <div className="card-item" key={value}>
                      <div className="card-item-label">{label}:</div>
                      <span className="card-item-value">
                        {requestedCandidatesList[0][value] || "N/A"}
                      </span>
                      {value === "courseName" && (
                        <span
                          className={`training-${requestedCandidatesList[0]?.approvalStatus.toLowerCase()}`}
                        >
                          {requestedCandidatesList[0]?.approvalStatus}
                        </span>
                      )}
                    </div>
                  ))}
              </div>
              {requestedCandidatesList[0]?.rejectionComment && (
                <div className="rejection-comment">
                  <span className="card-item-label">Rejection Comment:</span>
                  <div className="card-item-value">
                    {" "}
                    {requestedCandidatesList[0]?.rejectionComment}
                  </div>
                </div>
              )}
            </div>
            {requestedCandidatesList.length && (
              <div className="participant-list-container">
                <TrainingRequestedCandidateList
                  participantsList={participantsList}
                  isOEM={false}
                  onAddParticipant={addParticipant}
                  onRemoveParticipant={removeParticipant}
                  isCompleted={isCompleted}
                  isOEMRequested={isOEMRequested}
                  courseDetails={candidatesDetails?.[0]}
                />
              </div>
            )}
          </>
        ) : (
          <>
            <div className="training-request-heaeder">
              <ArrowBack
                fontSize="small"
                onClick={() => handleBackNavigation()}
              />
              <div className="title-container">
                <span className="training-title">Training</span>
                <div className="list-title">Training Request Received</div>
              </div>
            </div>
            <div className="request-details-card-container">
              No Details Found
            </div>
          </>
        )}
        <Dialog
          open={open}
          onClose={handleCloseComment}
          className="reject-comment-dialog"
        >
          <DialogTitle>Comments</DialogTitle>
          <DialogContent>
            <SiTextField
              value={rejectionComment}
              placeholder="Add Comments"
              multiline
              rows={5}
              variant="outlined"
              onChange={(e) => setRejectionComment(e.target.value)}
            />
          </DialogContent>
          <DialogActions className="dialog-btns">
            <Button variant="contained" onClick={handleCloseComment}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSaveComment}
              color="primary"
            >
              Reject
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default TrainingRequestedList;
